import React from "react";
import { FaCopyright } from "react-icons/fa";
function Footer() {
  return (
    <footer className="mx-2">
      <span className="mx-2">
        <FaCopyright />
      </span>
      2024 eCom store | Designed by Fatma Kurtgozu
    </footer>
  );
}

export default Footer;
